import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    aboutUsInfo: "",
    qrCodeVisible: false,
  },
  getters: {},
  mutations: {
    updateAboutUsInfo(state, val) {
      state.aboutUsInfo = val;
    },
    UPDATE_QRCODE_VISIBLE(state, val) {
      state.qrCodeVisible = val;
    },
  },
  actions: {
    updateQrCodeVisible(context, val) {
      context.commit("UPDATE_QRCODE_VISIBLE", val);
    },
  },
  modules: {},
});
